<div class="login-container">
  <div class="form-section">
    <div class="top-section">
      <div class="title">Welcome Back!</div>
      <div class="sub-title">
        New here? <a (click)="onClickSignUp()">Create an account</a>
      </div>
    </div>
    <form class="form" [formGroup]="loginForm" *ngIf="!isForgotPassword">
      <input name="email" formControlName="email" [ngClass]="{'error-border': (loginForm.get('email').value == '' && submitted)}" autocomplete="off" type="email" id="email" placeholder="e-mail">
      <div class="forgot-text" (click)="onClickForgotPassword()">Forgot Password?</div>
      <input name="password" formControlName="password"  [ngClass]="{'error-border': (loginForm.get('password').value == '' && submitted)}" autocomplete="off" type="password" id="password" placeholder="password">
      <button type="submit" (click)="onLogin()">Let's Start</button>
      <small *ngIf="submitted && loginForm.invalid">Please enter required fields!</small>
    </form>
    <form class="form" [formGroup]="forgotPasswordForm" *ngIf="isForgotPassword">
      <div class="get-otp" *ngIf="!isOtpGenerated">
        <input name="email" formControlName="email" autocomplete="off" type="email" id="email" placeholder="e-mail">
        <button type="submit" (click)="onGenerateOtp()">Get Otp</button>
      </div>
      <div class="verify-otp" *ngIf="isOtpGenerated && !isOtpVerified">
        <input name="email" formControlName="email" autocomplete="off" type="email" id="email" placeholder="e-mail">
        <input name="otp" formControlName="otp" autocomplete="off" type="text" id="otp" placeholder="otp">
        <button type="submit" (click)="onVerifyOtp()">Verify Otp</button>
      </div>
      <div class="update-password" *ngIf="isOtpGenerated && isOtpVerified">
        <input type="password" formControlName="newPassword" placeholder="new password">
        <input type="password" formControlName="confirmPassword" placeholder="confirm password">
        <button type="submit" (click)="onUpdatePassword()">Update Password</button>
      </div>
    </form>
  </div>
  <div class="img-section">
    <img src="../../../assets/images/icon 06.png" alt="">
  </div>
</div>
